import { TLoggedInUserInfo } from "../../../shared/types/loggedInUserInfo";
import { some } from "lodash";

export const useSubscriptions = (loggedInUserInfo: TLoggedInUserInfo) => {
    const subscriptions = loggedInUserInfo?.subscriptions || [];
    
    const isSubscribedToSeascape = some(subscriptions, (k) => k.type === 'Seascape');
    const isSubscribedToHorizon = some(subscriptions, (k) => k.type !== 'Seascape');

    return { isSubscribedToSeascape, isSubscribedToHorizon };
};
